export default [
  {
    title: "首页",
    key: "welcome",
    children: [
      {
        title: "新增记录",
        key: "welcome:new",
        children: [
          {
            title: "新增沟通",
            key: "welcome:new:communicate",
            children: [
              { title: "案件沟通查看", key: "welcome:new:communicate:cause" },
              {
                title: "判决后执行前沟通查看",
                key: "welcome:new:communicate:beforExec",
              },
              { title: "执行沟通查看", key: "welcome:new:communicate:InExec" },
              { title: "操作-已读", key: "welcome:new:communicate:setRead" },
              {
                title: "操作-批量已读",
                key: "welcome:new:communicate:setRead:batch",
              },
            ],
          },
          {
            title: "新增邮寄",
            key: "welcome:email",
            children: [
              { title: "查看", key: "welcome:email:index" },
              { title: "操作-已读", key: "welcome:email:setRead" },
              { title: "操作-批量已读", key: "welcome:email:setRead:batch" },
            ],
          },
        ],
      },
      {
        title: "进度超期",
        key: "welcome:step:over",
        children: [
          { title: "卷宗移交", key: "jzyjsj:home", key: "3" },
          { title: "诉讼材料制作", key: "ssclzb:home", key: "6" },
          { title: "调解材料制作", key: "zcclzz:home", key: "8" },
          { title: "一审受理审查", key: "ysslsc:home", key: "10" },
          { title: "调解受理审查", key: "zcslsc:home", key: "15" },
          { title: "一审调解", key: "ystj:home", key: "20" },
          { title: "一审立案", key: "ysla:home", key: "30" },
          { title: "调解立案", key: "ysla:home", key: "33" },
          { title: "一审待开庭", key: "sydkt:home", key: "40" },
          { title: "调解待开庭", key: "zcdkt:home", key: "43" },
          { title: "一审待判决", key: "ysdpj:home", key: "50" },
          { title: "调解待判决", key: "zcdpj:home", key: "53" },
          { title: "一审裁判文书", key: "yscpws:home", key: "60" },
          { title: "调解裁决书", key: "yscpws:home", key: "63" },
          { title: "二审受理审查", key: "esslsc:home", key: "70" },
          { title: "二审立案", key: "esla:home", key: "80" },
          { title: "二审待开庭", key: "esdkt:home", key: "90" },
          { title: "二审待判决", key: "esdpj:home", key: "100" },
          { title: "二审裁判文书", key: "escpws:home", key: "110" },
          { title: "重审立案", key: "csla:home", key: "111" },
          { title: "重审待开庭", key: "csdkt:home", key: "112" },
          { title: "重审待判决", key: "csdpj:home", key: "113" },
          { title: "重审裁判文书", key: "cscpws:home", key: "114" },
          { title: "再审受理审查", key: "zsslsc:home", key: "115" },
          { title: "再审立案", key: "zsla:home", key: "116" },
          { title: "再审待开庭", key: "zsdkt:home", key: "117" },
          { title: "再审待判决", key: "zsdpj:home", key: "118" },
          { title: "再审裁判文书", key: "zscpws:home", key: "119" },
          { title: "涉刑案件侦查", key: "sxajzc:home", key: "120" },
          { title: "检察院审判监督", key: "jcyspjd:home", key: "121" },
          { title: "中止/终止审理", key: "zzsl:home", key: "125" },
          { title: "执行受理审查", key: "zxslsc:home", key: "130" },
          { title: "执行立案", key: "zxla:home", key: "140" },
          { title: "执行中", key: "zxz:home", key: "150" },
          { title: "终本", key: "zb:home", key: "160" },
          { title: "恢复执行", key: "hfzx:home", key: "170" },
          { title: "结案", key: "ja:home", key: "180" },
        ],
      },
      {
        title: "分期履行",
        key: "welcome:loan",
        children: [{ title: "查看", key: "welcome:loan:index" }],
      },
      {
        title: "保全到期",
        key: "welcome:keep",
        children: [{ title: "查看", key: "welcome:keep:index" }],
      },
      {
        title: "诉讼时效",
        key: "welcome:causeAging",
        children: [
          { title: "查看", key: "welcome:causeAging:index" },
          { title: "操作-延期", key: "welcome:causeAging:delay" },
          { title: "操作-延期审核", key: "audit:causeAging" },
        ],
      },
      {
        title: "执行时效",
        key: "welcome:carry",
        children: [
          { title: "查看", key: "welcome:carry:index" },
          { title: "操作-延期", key: "welcome:carry:delay" },
        ],
      },
      {
        title: "邮寄提醒",
        key: "welcome:emailmsg",
        children: [
          { title: "查看", key: "welcome:emailmsg:index" },
          { title: "操作-延期", key: "welcome:emailmsg:delay" },
        ],
      },
      {
        title: "拍卖提醒",
        key: "welcome:sell",
        children: [
          { title: "查看", key: "welcome:sell:index" },
          { title: "关闭提醒", key: "welcome:sell:close" },
        ],
      },
    ],
  },
  {
    title: "案件管理",
    key: "debtorWithCause",
    children: [
      {
        title: "列表",
        key: "cause:index",
        children: [
          { title: "查看", key: "debtor:view" },
          { title: "新增被告", key: "debtor:add" },
        ],
      },
      {
        title: "详情",
        key: "debtorCauseInfo",
        children: [
          {
            title: "被告信息",
            key: "debtor:lists",
            children: [
              { title: "查看", key: "debtor:info" },
              { title: "修改", key: "debtor:edit" },
              { title: "删除", key: "debtor:del" },
            ],
          },
          {
            title: "附件汇总",
            key: "debtor:files:home",
            children: [
              { title: "查看", key: "debtor:files" },
              { title: "修改", key: "debtor:files:edit" },
              { title: "下载", key: "debtor:files:download" },
            ],
          },
          {
            title: "保全记录",
            key: "debtor:keep:home",
            children: [
              { title: "查看", key: "debtor:keep:index" },
              { title: "新增", key: "debtor:keep:add" },
              { title: "修改", key: "debtor:keep:edit" },
              { title: "续封", key: "debtor:keep:always" },
              { title: "删除", key: "debtor:keep:del" },
            ],
          },
          {
            title: "催收记录",
            key: "debtor:urge:home",
            children: [
              { title: "查看", key: "debtor:urge:index" },
              { title: "上传", key: "debtor:urge:add" },
              { title: "修改", key: "debtor:urge:edit" },
              { title: "删除", key: "debtor:urge:del" },
              { title: "下载", key: "debtor:urlge:download" },
            ],
          },
          {
            title: "关联被告信息",
            key: "debtor:other",
            children: [
              { title: "查看", key: "debtor:other:index" },
              { title: "新增", key: "debtor:other:add" },
              { title: "修改", key: "debtor:other:edit" },
              { title: "删除", key: "debtor:other:del" },
            ],
          },
          {
            title: "案件信息",
            key: "cause",
            children: [
              { title: "查看", key: "cause:lists" },
              { title: "新增", key: "cause:add" },
              { title: "修改", key: "cause:edit" },
              { title: "共享", key: "cause:share" },
              {
                title: "代理模式",
                key: "cause:agent:home",
                children: [
                  { title: "查看", key: "cause:agent:read" },
                  { title: "修改", key: "cause:agent:edit" },
                ],
              },
              {
                title: "特殊备注",
                key: "cause:innerCommnet:home",
                children: [
                  { title: "查看", key: "cause:innerCommnet:read" },
                  { title: "新增", key: "cause:innerCommnet:add" },
                  { title: "修改", key: "cause:innerComment:edit" },
                  {
                    title: "作废案件特殊备注查看",
                    key: "cause:invalid:innerComment:read",
                  },
                  {
                    title: "作废案件特殊备注修改",
                    key: "cause:invaild:innerComment:edit",
                  },
                ],
              },
              { title: "删除", key: "cause:delete" },
              { title: "作废", key: "cause:invaild" },
              { title: "作废查看", key: "cause:lists:invaild" },
            ],
          },
          {
            title: "财产信息",
            key: "case:debtorCar:home",
            children: [
              { title: "查看", key: "case:debtorCar:index" },
              { title: "新增", key: "case:debtorCar:add" },
              { title: "修改", key: "case:debtorCar:edit" },
              { title: "删除", key: "case:debtorCar:delete" },
            ],
          },
          {
            //仔细修改
            title: "案件沟通记录",
            key: "case:comments",
            children: [
              {
                title: "裁决前沟通记录",
                key: "case:communication:before",
                children: [
                  { title: "查看", key: "case:communication:pjbefore.index" },
                  { title: "新增", key: "case:communication:pjbefore:add" },
                  { title: "修改", key: "case:communication:pjbefore:edit" },
                  { title: "删除", key: "case:communication:pjbefore:del" },
                ],
              },
              {
                title: "执行前沟通记录",
                key: "case:communication:zxbefore",
                children: [
                  { title: "查看", key: "case:communication:zxbefore:index" },
                  { title: "新增", key: "case:communication:zxbefore:add" },
                  { title: "修改", key: "case:communication:zxbefore:edit" },
                  { title: "删除", key: "case:communication:zxbefore:del" },
                ],
              },
              {
                title: "执行后沟通记录",
                key: "case:debtorCar:zxafter",
                children: [
                  { title: "查看", key: "case:communication:zxafter:index" },
                  { title: "新增", key: "case:communication:zxafter:add" },
                  { title: "修改", key: "case:communication:zxafter:edit" },
                  { title: "删除", key: "case:communication:zxafter:del" },
                ],
              },
              {
                title: "作废案件沟通记录查看",
                key: "cancel:cause:communication:view",
              },
              {
                title: "作废案件沟通记录修改",
                key: "cancel:cause:communication:edit",
              },
            ],
          },
          {
            title: "案件进度",
            key: "case.step",
            children: [
              {
                title: "进度查看",
                key: "step:lists",
                children: [
                  { title: "卷宗移交", key: "jzyjsj:list", key: "3" },
                  { title: "诉讼材料制作", key: "ssclzb:list", key: "6" },
                  { title: "调解材料制作", key: "zcclzz:list", key: "8" },
                  { title: "一审受理审查", key: "ysslsc:list", key: "10" },
                  { title: "调解受理审查", key: "zcslsc:list", key: "15" },
                  { title: "一审调解", key: "ystj:list", key: "20" },
                  { title: "一审立案", key: "ysla:list", key: "30" },
                  { title: "调解立案", key: "ysla:list", key: "33" },
                  { title: "一审待开庭", key: "sydkt:list", key: "40" },
                  { title: "调解待开庭", key: "zcdkt:list", key: "43" },
                  { title: "一审待判决", key: "ysdpj:list", key: "50" },
                  { title: "调解待判决", key: "zcdpj:list", key: "53" },
                  { title: "一审裁判文书", key: "yscpws:list", key: "60" },
                  { title: "调解裁决书", key: "yscpws:list", key: "63" },
                  { title: "二审受理审查", key: "esslsc:list", key: "70" },
                  { title: "二审立案", key: "esla:list", key: "80" },
                  { title: "二审待开庭", key: "esdkt:list", key: "90" },
                  { title: "二审待判决", key: "esdpj:list", key: "100" },
                  { title: "二审裁判文书", key: "escpws:list", key: "110" },
                  { title: "重审立案", key: "csla:list", key: "111" },
                  { title: "重审待开庭", key: "csdkt:list", key: "112" },
                  { title: "重审待判决", key: "csdpj:list", key: "113" },
                  { title: "重审裁判文书", key: "cscpws:list", key: "114" },
                  { title: "再审受理审查", key: "zsslsc:list", key: "115" },
                  { title: "再审立案", key: "zsla:list", key: "116" },
                  { title: "再审待开庭", key: "zsdkt:list", key: "117" },
                  { title: "再审待判决", key: "zsdpj:list", key: "118" },
                  { title: "再审裁判文书", key: "zscpws:list", key: "119" },
                  { title: "涉刑案件侦查", key: "sxajzc:list", key: "120" },
                  { title: "检察院审判监督", key: "jcyspjd:list", key: "121" },
                  { title: "中止/终止审理", key: "zzsl:list", key: "125" },
                  { title: "执行受理审查", key: "zxslsc:list", key: "130" },
                  { title: "执行立案", key: "zxla:list", key: "140" },
                  { title: "执行中", key: "zxz:list", key: "150" },
                  { title: "终本", key: "zb:list", key: "160" },
                  { title: "恢复执行", key: "hfzx:list", key: "170" },
                  { title: "结案", key: "ja:list", key: "180" },
                ],
              },
              {
                title: "进度添加",
                key: "step:add",
                children: [
                  { title: "卷宗移交", key: "jzyjsj:add", key: "3" },
                  { title: "诉讼材料制作", key: "ssclzb:add", key: "6" },
                  { title: "调解材料制作", key: "zcclzz:add", key: "8" },
                  { title: "一审受理审查", key: "ysslsc:add", key: "10" },
                  { title: "调解受理审查", key: "zcslsc:add", key: "15" },
                  { title: "一审调解", key: "ystj:add", key: "20" },
                  { title: "一审立案", key: "ysla:add", key: "30" },
                  { title: "调解立案", key: "ysla:add", key: "33" },
                  { title: "一审待开庭", key: "sydkt:add", key: "40" },
                  { title: "调解待开庭", key: "zcdkt:add", key: "43" },
                  { title: "一审待判决", key: "ysdpj:add", key: "50" },
                  { title: "调解待判决", key: "zcdpj:add", key: "53" },
                  { title: "一审裁判文书", key: "yscpws:add", key: "60" },
                  { title: "调解裁决书", key: "yscpws:add", key: "63" },
                  { title: "二审受理审查", key: "esslsc:add", key: "70" },
                  { title: "二审立案", key: "esla:add", key: "80" },
                  { title: "二审待开庭", key: "esdkt:add", key: "90" },
                  { title: "二审待判决", key: "esdpj:add", key: "100" },
                  { title: "二审裁判文书", key: "escpws:add", key: "110" },
                  { title: "重审立案", key: "csla:add", key: "111" },
                  { title: "重审待开庭", key: "csdkt:add", key: "112" },
                  { title: "重审待判决", key: "csdpj:add", key: "113" },
                  { title: "重审裁判文书", key: "cscpws:add", key: "114" },
                  { title: "再审受理审查", key: "zsslsc:add", key: "115" },
                  { title: "再审立案", key: "zsla:add", key: "116" },
                  { title: "再审待开庭", key: "zsdkt:add", key: "117" },
                  { title: "再审待判决", key: "zsdpj:add", key: "118" },
                  { title: "再审裁判文书", key: "zscpws:add", key: "119" },
                  { title: "涉刑案件侦查", key: "sxajzc:add", key: "120" },
                  { title: "检察院审判监督", key: "jcyspjd:add", key: "121" },
                  { title: "中止/终止审理", key: "zzsl:add", key: "125" },
                  { title: "执行受理审查", key: "zxslsc:add", key: "130" },
                  { title: "执行立案", key: "zxla:add", key: "140" },
                  { title: "执行中", key: "zxz:add", key: "150" },
                  { title: "终本", key: "zb:add", key: "160" },
                  { title: "恢复执行", key: "hfzx:add", key: "170" },
                  { title: "结案", key: "ja:add", key: "180" },
                ],
              },
              {
                title: "进度修改",
                key: "step:edit",
                children: [
                  { title: "卷宗移交", key: "jzyjsj:edit", key: "3" },
                  { title: "诉讼材料制作", key: "ssclzb:edit", key: "6" },
                  { title: "调解材料制作", key: "zcclzz:edit", key: "8" },
                  { title: "一审受理审查", key: "ysslsc:edit", key: "10" },
                  { title: "调解受理审查", key: "zcslsc:edit", key: "15" },
                  { title: "一审调解", key: "ystj:edit", key: "20" },
                  { title: "一审立案", key: "ysla:edit", key: "30" },
                  { title: "调解立案", key: "ysla:edit", key: "33" },
                  { title: "一审待开庭", key: "sydkt:edit", key: "40" },
                  { title: "调解待开庭", key: "zcdkt:edit", key: "43" },
                  { title: "一审待判决", key: "ysdpj:edit", key: "50" },
                  { title: "调解待判决", key: "zcdpj:edit", key: "53" },
                  { title: "一审裁判文书", key: "yscpws:edit", key: "60" },
                  { title: "调解裁决书", key: "yscpws:edit", key: "63" },
                  { title: "二审受理审查", key: "esslsc:edit", key: "70" },
                  { title: "二审立案", key: "esla:edit", key: "80" },
                  { title: "二审待开庭", key: "esdkt:edit", key: "90" },
                  { title: "二审待判决", key: "esdpj:edit", key: "100" },
                  { title: "二审裁判文书", key: "escpws:edit", key: "110" },
                  { title: "重审立案", key: "csla:edit", key: "111" },
                  { title: "重审待开庭", key: "csdkt:edit", key: "112" },
                  { title: "重审待判决", key: "csdpj:edit", key: "113" },
                  { title: "重审裁判文书", key: "cscpws:edit", key: "114" },
                  { title: "再审受理审查", key: "zsslsc:edit", key: "115" },
                  { title: "再审立案", key: "zsla:edit", key: "116" },
                  { title: "再审待开庭", key: "zsdkt:edit", key: "117" },
                  { title: "再审待判决", key: "zsdpj:edit", key: "118" },
                  { title: "再审裁判文书", key: "zscpws:edit", key: "119" },
                  { title: "涉刑案件侦查", key: "sxajzc:edit", key: "120" },
                  { title: "检察院审判监督", key: "jcyspjd:edit", key: "121" },
                  { title: "中止/终止审理", key: "zzsl:edit", key: "125" },
                  { title: "执行受理审查", key: "zxslsc:edit", key: "130" },
                  { title: "执行立案", key: "zxla:edit", key: "140" },
                  { title: "执行中", key: "zxz:edit", key: "150" },
                  { title: "终本", key: "zb:edit", key: "160" },
                  { title: "恢复执行", key: "hfzx:edit", key: "170" },
                  { title: "结案", key: "ja:edit", key: "180" },
                ],
              },
              {
                title: "进度延期",
                key: "step:delay",
                children: [
                  { title: "卷宗移交", key: "jzyjsj:delayed", key: "3" },
                  { title: "诉讼材料制作", key: "ssclzb:delayed", key: "6" },
                  { title: "调解材料制作", key: "zcclzz:delayed", key: "8" },
                  { title: "一审受理审查", key: "ysslsc:delayed", key: "10" },
                  { title: "调解受理审查", key: "zcslsc:delayed", key: "15" },
                  { title: "一审调解", key: "ystj:delayed", key: "20" },
                  { title: "一审立案", key: "ysla:delayed", key: "30" },
                  { title: "调解立案", key: "ysla:delayed", key: "33" },
                  { title: "一审待开庭", key: "sydkt:delayed", key: "40" },
                  { title: "调解待开庭", key: "zcdkt:delayed", key: "43" },
                  { title: "一审待判决", key: "ysdpj:delayed", key: "50" },
                  { title: "调解待判决", key: "zcdpj:delayed", key: "53" },
                  { title: "一审裁判文书", key: "yscpws:delayed", key: "60" },
                  { title: "调解裁决书", key: "yscpws:delayed", key: "63" },
                  { title: "二审受理审查", key: "esslsc:delayed", key: "70" },
                  { title: "二审立案", key: "esla:delayed", key: "80" },
                  { title: "二审待开庭", key: "esdkt:delayed", key: "90" },
                  { title: "二审待判决", key: "esdpj:delayed", key: "100" },
                  { title: "二审裁判文书", key: "escpws:delayed", key: "110" },
                  { title: "重审立案", key: "csla:delayed", key: "111" },
                  { title: "重审待开庭", key: "csdkt:delayed", key: "112" },
                  { title: "重审待判决", key: "csdpj:delayed", key: "113" },
                  { title: "重审裁判文书", key: "cscpws:delayed", key: "114" },
                  { title: "再审受理审查", key: "zsslsc:delayed", key: "115" },
                  { title: "再审立案", key: "zsla:delayed", key: "116" },
                  { title: "再审待开庭", key: "zsdkt:delayed", key: "117" },
                  { title: "再审待判决", key: "zsdpj:delayed", key: "118" },
                  { title: "再审裁判文书", key: "zscpws:delayed", key: "119" },
                  { title: "涉刑案件侦查", key: "sxajzc:delayed", key: "120" },
                  {
                    title: "检察院审判监督",
                    key: "jcyspjd:delayed",
                    key: "121",
                  },
                  { title: "中止/终止审理", key: "zzsl:delayed", key: "125" },
                  { title: "执行受理审查", key: "zxslsc:delayed", key: "130" },
                  { title: "执行立案", key: "zxla:delayed", key: "140" },
                  { title: "执行中", key: "zxz:delayed", key: "150" },
                  { title: "终本", key: "zb:delayed", key: "160" },
                  { title: "恢复执行", key: "hfzx:delayed", key: "170" },
                  { title: "结案", key: "ja:delayed", key: "180" },
                ],
              },
              {
                title: "进度删除",
                key: "step:delete",
                children: [
                  { title: "卷宗移交", key: "jzyjsj:del", key: "3" },
                  { title: "诉讼材料制作", key: "ssclzb:del", key: "6" },
                  { title: "调解材料制作", key: "zcclzz:del", key: "8" },
                  { title: "一审受理审查", key: "ysslsc:del", key: "10" },
                  { title: "调解受理审查", key: "zcslsc:del", key: "15" },
                  { title: "一审调解", key: "ystj:del", key: "20" },
                  { title: "一审立案", key: "ysla:del", key: "30" },
                  { title: "调解立案", key: "ysla:del", key: "33" },
                  { title: "一审待开庭", key: "sydkt:del", key: "40" },
                  { title: "调解待开庭", key: "zcdkt:del", key: "43" },
                  { title: "一审待判决", key: "ysdpj:del", key: "50" },
                  { title: "调解待判决", key: "zcdpj:del", key: "53" },
                  { title: "一审裁判文书", key: "yscpws:del", key: "60" },
                  { title: "调解裁决书", key: "yscpws:del", key: "63" },
                  { title: "二审受理审查", key: "esslsc:del", key: "70" },
                  { title: "二审立案", key: "esla:del", key: "80" },
                  { title: "二审待开庭", key: "esdkt:del", key: "90" },
                  { title: "二审待判决", key: "esdpj:del", key: "100" },
                  { title: "二审裁判文书", key: "escpws:del", key: "110" },
                  { title: "重审立案", key: "csla:del", key: "111" },
                  { title: "重审待开庭", key: "csdkt:del", key: "112" },
                  { title: "重审待判决", key: "csdpj:del", key: "113" },
                  { title: "重审裁判文书", key: "cscpws:del", key: "114" },
                  { title: "再审受理审查", key: "zsslsc:del", key: "115" },
                  { title: "再审立案", key: "zsla:del", key: "116" },
                  { title: "再审待开庭", key: "zsdkt:del", key: "117" },
                  { title: "再审待判决", key: "zsdpj:del", key: "118" },
                  { title: "再审裁判文书", key: "zscpws:del", key: "119" },
                  { title: "涉刑案件侦查", key: "sxajzc:del", key: "120" },
                  { title: "检察院审判监督", key: "jcyspjd:del", key: "121" },
                  { title: "中止/终止审理", key: "zzsl:del", key: "125" },
                  { title: "执行受理审查", key: "zxslsc:del", key: "130" },
                  { title: "执行立案", key: "zxla:del", key: "140" },
                  { title: "执行中", key: "zxz:del", key: "150" },
                  { title: "终本", key: "zb:del", key: "160" },
                  { title: "恢复执行", key: "hfzx:del", key: "170" },
                  { title: "结案", key: "ja:del", key: "180" },
                ],
              },
              { title: "结案后进度添加", key: "cause:step:ja:add" },
              { title: "结案后进度修改", key: "cause:step:ja:edit" },
              { title: "作废后进度查看", key: "cause:invaild:step:lists" },
              { title: "作废后进度修改", key: "cause:invaildl:step:edit" },
            ],
          },
          {
            title: "主张债权及费用计算",
            key: "dktFee",
            children: [{ title: "查看", key: "dktFee:do" }],
          },
          {
            title: "确认债权及费用计算",
            key: "credit",
            children: [
              { title: "查看", key: "cause:credit:lists" },
              { title: "修改", key: "cause:credit:edit" },
              { title: "修改审核", key: "audit:cause:credit:edit" },
            ],
          },
          {
            title: "退费计算",
            key: "refundFee",
            children: [
              { title: "查看", key: "return:read" },
              { title: "修改", key: "return:edit" },
              { title: "作废修改", key: "return:invaild:edit" },
            ],
          },
          // {
          //   title: '操作记录', key: 'actionLog',
          //   children: [
          //     { title: '查看', key: 'action:lists' }
          //   ]
          // }
        ],
      },
    ],
  },
  {
    title: "分期管理",
    key: "payee",
    children: [
      {
        title: "列表",
        key: "credit:loan:lists",
        children: [
          { title: "查看", key: "loan:lists" },
          { title: "新增", key: "credit:loan:add" },
        ],
      },
      {
        title: "详情",
        key: "credit:loan:info",
        children: [
          { title: "分期详情查看", key: "loan:info:lists" },
          { title: "分期添加", key: "loan:add" },
          { title: "分期信息修改", key: "credit:loan:edit" },
          { title: "分期信息修改审核", key: "audit:loan" },
          { title: "申请执行", key: "credit:loan:do" },
        ],
      },
    ],
  },
  {
    title: "案款管理",
    key: "loan",
    children: [
      {
        title: "列表",
        key: "credit:payee:lists",
        children: [
          { title: "查看", key: "payee:lists" },
          { title: "新增", key: "credit:payee/add" },
        ],
      },
      {
        title: "详情",
        key: "credit/payee/info",
        children: [
          { title: "案款详情查看", key: "payee:info:lists" },
          { title: "案款添加", key: "payee:add" },
          { title: "案款撤销", key: "payee:recall" },
          { title: "案款删除", key: "payee:del" },
          { title: "案款撤销审核", key: "payee:audit" },
          { title: "案款记录添加", key: "credit:payee:add" },
        ],
      },
    ],
  },
  {
    title: "档案管理",
    key: "letters",
    children: [
      {
        title: "律师函件",
        key: "letters:view",
        children: [
          { title: "查看", key: "letters:view:index" },
          { title: "修改", key: "letters:view:edit" },
          { title: "新增", key: "letters:view:add" },
          { title: "删除", key: "letters:view:del" },
        ],
      },
    ],
  },

  {
    title: "审核管理",
    key: "audit",
    children: [
      {
        title: "列表",
        key: "audit:list",
        children: [
          { title: "查看", key: "info:audit:lists" },
          {
            title: "审核",
            key: "audit:check",
            children: [
              { title: "新增被告审核", key: "debtor:new:audit" },
              { title: "被告修改审核", key: "debtor:audits" },
              { title: "关联被告审核", key: "audit:otherDebtor" },
              { title: "案件作废审核", key: "cause.cancel.aduit" },
              { title: "案件修改审核", key: "cause.edit.audit" },
              { title: "特殊备注新增审核", key: "special.remark.add.audit" },
              { title: "特殊备注修改审核", key: "audit:cause:innerComment" },
              { title: "沟通记录修改审核", key: "communication.edit.audit" },
              { title: "沟通记录删除审核", key: "communication.delete.audit" },
              { title: "进度延期审核", key: "audit:step:delay" },
              { title: "进度删除审核", key: "jdscsh:lists" },
              { title: "进度附件删除审核", key: "cause:step:del:audit" },
            ],
          },
        ],
      },
    ],
  },

  {
    title: "案件统计",
    key: "causeAnalyse",
    children: [
      { title: "查看", key: "statis:cause" },
      { title: "导出", key: "cause:export" },
    ],
  },
  {
    title: "法院统计",
    key: "statis:court",
    children: [{ title: "查看", key: "statis:court:lists" }],
  },
  {
    title: "业务统计",
    key: "statis:ywfx",
    children: [{ title: "查看", key: "statis:ywfx:lists" }],
  },
  {
    title: "结清统计",
    key: "statis:settle:cause",
    children: [{ title: "查看", key: "statis:ywfx:lists" }],
  },
  {
    title: "作废统计",
    key: "statis:cancel:cause",
    children: [
      { title: "查看", key: "statis:cancel:lists" },
      { title: "导出", key: "export:cancen:cause" },
    ],
  },

  {
    title: "其他",
    key: "other",
    children: [{ title: "修改密码", key: "repass" }],
  },
  {
    title: "基础管理",
    key: "base",
    children: [
      {
        title: "法院目录",
        key: "court",
        children: [
          { title: "查看", key: "court:info" },
          { title: "新增", key: "court:add" },
          // { title: "名称修改", key: "K02" },
          // { title: "其他修改", key: "K03" },
          { title: "修改", key: "court:edit" },
          { title: "删除", key: "court:del" },
        ],
      },
      {
        title: "案件主体",
        key: "accuser",
        children: [
          { title: "查看", key: "accsuer:index" },
          { title: "新增", key: "accuser:add" },
          { title: "修改", key: "accuser:edit" },
        ],
      },
      {
        title: "业务部门",
        key: "team",
        children: [
          { title: "查看", key: "team:index" },
          { title: "新增", key: "team:add" },
          { title: "修改", key: "team:edit" },
          { title: "删除", key: "team:delete" },
        ],
      },
      {
        title: "进度期限",
        key: "over",
        children: [
          { title: "查看", key: "over:index" },
          { title: "修改", key: "over:edit" },
        ],
      },
      {
        title: "业务类型",
        key: "car",
        children: [
          { title: "查看", key: "car:index" },
          { title: "新增", key: "car:add" },
          { title: "修改", key: "car:edit" },
          { title: "删除", key: "car:del" },
        ],
      },
      {
        title: "案件案由",
        key: "reason",
        children: [
          { title: "查看", key: "reason:index" },
          { title: "新增", key: "reason:add" },
          { title: "修改", key: "reason:edit" },
          { title: "删除", key: "reason:del" },
        ],
      },
      {
        title: "仲裁机构",
        key: "arbitrate",
        children: [
          { title: "查看", key: "arbitrate:index" },
          { title: "新增", key: "reason:add" },
          { title: "修改", key: "reason:edit" },
          { title: "删除", key: "reason:del" },
        ],
      },
    ],
  },
];
